import { NotificationBar } from "@emanprague/ppaskit";
import React from "react";
import { useId } from "../../helpers/utils";
import { observer } from "mobx-react-lite";

interface SapDashboardNoticeProps {
  text: string;
  onCancel: () => void;
  translateFunc: (key: string) => string;
}

// Used for messages from SAP for Partner or Supply Point
export const SapDashboardNotice: React.FunctionComponent<SapDashboardNoticeProps> = observer(
  ({ text, onCancel, translateFunc }) => {
    const contentId = useId("notificationContent");

    return (
      <NotificationBar
        variant="warning"
        className="mb-3"
        cancellable
        onCancel={onCancel}
        translateFunc={translateFunc}
        cancelButtonInfoId={contentId}>
        <div id={contentId} className="text-center" dangerouslySetInnerHTML={{ __html: text }} />
      </NotificationBar>
    );
  }
);
